import { ref } from 'vue';

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

const deferredPrompt = ref<BeforeInstallPromptEvent | null>(null);
const isInstallable = ref(false);
const isInstalled = ref(false);

let initialized = false;

function init() {
  if (initialized) return;
  initialized = true;

  // Detect if already running as installed PWA
  if (window.matchMedia('(display-mode: standalone)').matches) {
    isInstalled.value = true;
    return;
  }

  window.addEventListener('beforeinstallprompt', (e: Event) => {
    e.preventDefault();
    deferredPrompt.value = e as BeforeInstallPromptEvent;
    isInstallable.value = true;
  });

  window.addEventListener('appinstalled', () => {
    isInstalled.value = true;
    isInstallable.value = false;
    deferredPrompt.value = null;
  });
}

async function promptInstall(): Promise<boolean> {
  if (!deferredPrompt.value) return false;

  await deferredPrompt.value.prompt();
  const { outcome } = await deferredPrompt.value.userChoice;

  if (outcome === 'accepted') {
    deferredPrompt.value = null;
    isInstallable.value = false;
    return true;
  }
  return false;
}

export function usePwaInstall() {
  init();
  return {
    isInstallable,
    isInstalled,
    promptInstall,
  };
}
